module.exports = __webpack_public_path__ + "media/FCB-Preview.9dc69169.mp4";